// extracted by mini-css-extract-plugin
export default {"adminselector":"Administration_adminselector__9R6NV","active":"Administration_active__RI6N9","displaycomponent":"Administration_displaycomponent__IWRQG"};